import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * @typedef {object} RedeemResult
 * @property {boolean} success Whether redemption succeeded
 * @property {string} [organizationId] The org ID user was added to
 * @property {string} [teamId] The team ID user was added to
 * @property {string} [error] Error code if failed
 */

/**
 * Redeems an invite for a user via the redeemInvite callable function.
 * Handles adding them to org and team, updating claims, and refreshing the token.
 * @param {string} token The invite token
 * @returns {Promise<RedeemResult>} The redeem information
 */
export async function redeemInvite(token) {
  try {
    const result = await FirebaseAdapter().functions.redeemInvite({ token });

    if (result.success) {
      const firebaseUser = FirebaseAdapter().authn.getCurrentUser();
      if (firebaseUser) {
        await firebaseUser.getIdTokenResult(true);
      }
    }

    return result;
  } catch (error) {
    const errorCode = error.code || "UNKNOWN_ERROR";
    const errorMessage = error.message || "Unknown error occurred";

    console.error("Redeem invite error:", { errorCode, errorMessage });

    return {
      success: false,
      error: errorCode,
    };
  }
}
